import {
  useEsquemaCalendarioVacinalQuery,
  useRegistrosAplicadosQuery,
  useRegistrosDoseLazyQuery,
} from 'graphql/hooks.generated'
import { GrupoAlvoVacinacaoEnum } from 'graphql/types.generated'
import React, { useMemo, useState } from 'react'
import {
  convertEsquemaCalendarioVacinalQueryToProps,
  updateDosesProps,
} from 'view/atendimentos/atendimento-vacinacao/condicoes/converter'
import { RegistroVacinacaoFormModel } from 'view/atendimentos/atendimento-vacinacao/model'
import { VacinacaoModal } from 'view/atendimentos/atendimento-vacinacao/VacinacaoModal'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { VacinacaoPanel } from '../components/vacinacao/VacinacaoPanel'
import { EstadoBotaoCalendario } from './VacinacaoView'

interface VacinacaoCalendarioViewProps {
  cidadao: CidadaoAtendimento
  gestante: boolean
  dataAtendimento: Instant
  estadoBotaoCalendario: EstadoBotaoCalendario
  grupoAlvoCidadao: GrupoAlvoVacinacaoEnum
  prontuarioId: string
  registros: RegistroVacinacaoFormModel[]
}

export interface RegistrosAplicadosDto {
  imunobiologicoId: ID
  imunobiologicoSigla: string
  imunobiologicoNome: string
  imunobiologicoNomeFiltro: string
  doseId: ID
  doseNomeApresentacao: string
  doseNome: string
  doseSigla: string
  dataAprazamento: LocalDate
  dataRegistroAprazamento: LocalDate
}

export interface InfoCardModalVacinacao {
  imunobiologicoId: ID
  imunobiologicoNome: string
  imunobiologicoSigla: string
  doseId: ID
  doseNome: string
  faixaEtaria: string
}

export function VacinacaoCalendarioView(props: VacinacaoCalendarioViewProps) {
  const { cidadao, gestante, dataAtendimento, estadoBotaoCalendario, grupoAlvoCidadao, prontuarioId } = props

  const [isVacinacaoModalOpen, setIsVacinacaoModalOpen] = useState(false)
  const [registrosDoseLazyQuery, { data: registrosDoseQueryResult, loading }] = useRegistrosDoseLazyQuery()
  const [infoCardModal, setInfoCardModal] = useState<InfoCardModalVacinacao>(null)

  const { data } = useEsquemaCalendarioVacinalQuery({
    variables: {
      input: {
        sexo: cidadao.sexo,
        grupoAlvo: grupoAlvoCidadao,
        gestante: gestante,
      },
    },
    fetchPolicy: 'cache-first',
  })

  const {
    data: { registrosAplicados },
  } = useRegistrosAplicadosQuery({
    variables: {
      prontuarioId: prontuarioId,
    },
    fetchPolicy: 'cache-first',
  })

  return useMemo(() => {
    const handleOnDoseClicked = (info: InfoCardModalVacinacao) => {
      setInfoCardModal(info)
      setIsVacinacaoModalOpen(true)
    }

    const handleVacinacaoModalClose = () => {
      setInfoCardModal(null)
      setIsVacinacaoModalOpen(false)
    }

    const handleOnSubmit = (formValues: RegistroVacinacaoFormModel) => {
      props.registros.push(formValues)
    }

    const calendarioVacinalProps = convertEsquemaCalendarioVacinalQueryToProps(
      data,
      cidadao,
      dataAtendimento,
      prontuarioId,
      registrosAplicados
    )

    const clonedDoses = JSON.parse(JSON.stringify(calendarioVacinalProps))

    const calendarioDosesProps = updateDosesProps(clonedDoses.abaCalendario, props.registros)
    const outrasDosesProps = updateDosesProps(clonedDoses.abaOutros, props.registros)

    return (
      <>
        <VacinacaoModal
          handleModalClose={handleVacinacaoModalClose}
          registrosDoseQueryResult={registrosDoseQueryResult}
          modalOpen={isVacinacaoModalOpen}
          handleOnSubmit={handleOnSubmit}
          setIsVacinacaoModalOpen={setIsVacinacaoModalOpen}
          loading={loading}
          infoCardModal={infoCardModal}
          registrosModificados={props.registros}
        />

        {estadoBotaoCalendario === 'CALENDARIO_VACINAL' ? (
          <VacinacaoPanel
            imunobiologicos={calendarioDosesProps}
            handleOnDoseClicked={handleOnDoseClicked}
            registrosDoseLazyQuery={registrosDoseLazyQuery}
          />
        ) : (
          <VacinacaoPanel
            imunobiologicos={outrasDosesProps}
            outrosImunobiologicos
            handleOnDoseClicked={handleOnDoseClicked}
            registrosDoseLazyQuery={registrosDoseLazyQuery}
          />
        )}
      </>
    )
  }, [
    cidadao,
    data,
    dataAtendimento,
    estadoBotaoCalendario,
    infoCardModal,
    isVacinacaoModalOpen,
    registrosAplicados,
    loading,
    registrosDoseQueryResult,
    prontuarioId,
    registrosDoseLazyQuery,
    props.registros,
  ])
}
